define('extensions/knockout/functions/average', [
    'knockout'
], (ko) => {
    /**
     * decrements value if it's a number. throws exception otherwise;
     */
    ko.subscribable.fn.average = function () {
        return ko.pureComputed(() => _(this()).reduce((result, value) => result + value, 0) / (this().length || 1));
    };
});